import CustomModal from "../../../common/components/modal/CustomDetailModal";
import { Divider, Row, SizedBox } from "../../../common/components/CommonBaseComponents";
import { TitleAndInput } from "../../../common/components/input/TitleAndInput";
import React, { useState } from "react";
import { C3Text } from "../../../common/components/text/CustomText";
import SecondaryButton from "../../../common/components/button/SecondaryButton";
import Translate from "../../../common/translate/Translate";
import PrimaryButton from "../../../common/components/button/PrimaryButton";
import CustomPopup from "../../../common/components/popup/CustomPopup";
import { useNavigate } from "react-router-dom";
import { Theme } from "../../../common/Theme";
import StoreLocationModal from "./StoreLocationModal";
import StoreService from "../../../service/StoreService";

const currencyValues = [
    { label: "Baht(฿)", value: "baht" },
    { label: "Won(₩)", value: "won" },
];

export function StoreEditModal({ isOpen, onClose, storeId, storeDetail, onSave }) {
    const navigation = useNavigate();
    const service = new StoreService();
    const [name, setName] = useState("");
    const [selectedCurrency, setSelectedCurrency] = useState("baht");
    const [address1, setAddress1] = useState("");
    const [address2, setAddress2] = useState("");
    const [city, setCity] = useState("");
    const [selectedStates, setSelectedStates] = useState("");
    const [statesValues, setStatesValues] = useState([
        { label: "Chomburi", value: "Chomburi" },
        { label: "Bangkok", value: "Bangkok" },
        { label: "Pathum Thani", value: "Pathum Thani" },
        { label: "Chiang Mai", value: "Chiang Mai" },
    ]);
    const [latitude, setLatitude] = useState("");
    const [longitude, setLongitude] = useState("");
    const [zip, setZip] = useState("");
    const [phone, setPhone] = useState("");
    const [email, setEmail] = useState("");
    const [introduction, setIntroduction] = useState("");
    const [image, setImage] = useState();

    // Cancel Popup
    const [isCancelPopupOpen, setIsCancelPopupOpen] = useState(false);

    const handleCancelClose = () => {
        setIsCancelPopupOpen(false);
    };

    const handleCancelOk = () => {
        setIsCancelPopupOpen(false);
        onClose();
    };

    // Delete Popup
    const [isDeletePopupOpen, setIsDeletePopupOpen] = useState(false);

    const handleDeleteClose = () => {
        setIsDeletePopupOpen(false);
    };

    const handleDeleteOk = () => {
        service
            .deleteStore({ storeId })
            .then(() => {
                setIsDeletePopupOpen(false);
                onClose();
                navigation(-1);
            })
            .catch((error) => {
                console.error("Error deleting store:", error);
                setIsDeletePopupOpen(false);
            });
    };

    // location modal
    const [openLocationModal, setOpenLocationModal] = useState(false);

    const handleLocationConfirm = ({ latitude, longitude, zipCode }) => {
        setLatitude(latitude);
        setLongitude(longitude);
        setZip(zipCode);
    };

    const handleUpdate = () => {
        const reqDto = {
            request: {
                storeName: name,
                storeType: 0,
                currency: selectedCurrency,
                address1: address1,
                address2: address2 || undefined,
                city: city,
                states: selectedStates,
                zipcode: zip || undefined,
                phone: phone,
                lTime: Intl.DateTimeFormat().resolvedOptions().timeZone,
                longitude: latitude && longitude ? [latitude, longitude] : undefined,
                openLocation: true,
                information: introduction || undefined,
                isReservationEnable: true,
            },
        };
        service
            .updateStore(reqDto)
            .then(() => {
                onClose();
                if (onSave) onSave();
            })
            .catch((error) => {
                console.error("Error updating store:", error);
            });
    };

    return (
        <CustomModal
            title={"Edit Store"}
            isOpen={isOpen}
            onClose={() => setIsCancelPopupOpen(true)}
            width={"552px"}
            side={"right"}
        >
            <SizedBox
                width={"100%"}
                height={"100%"}
                border={"solid 1px #E6E6E9"}
                borderRadius={"16px"}
                alignItem={"flex-start"}
                justifyContent={"flex-start"}
                padding={"20px 20px"}
            >
                <TitleAndInput
                    title={"Name"}
                    type={"normal"}
                    placeholder={"Store Name"}
                    inputValue={name}
                    setInputValue={setName}
                    isRequired
                />
                <Divider marginTop={"11px"} thickness={"0px"} />
                <TitleAndInput
                    title={"Currency"}
                    type={"select"}
                    inputValue={selectedCurrency}
                    setInputValue={setSelectedCurrency}
                    dropdownValues={currencyValues}
                />
                <Divider marginTop={"11px"} marginBottom={"11px"} />
                <TitleAndInput
                    title={"Address"}
                    type={"inputs"}
                    gap={"11px"}
                    inputs={[
                        { type: "normal", placeholder: "Address 1", inputValue: address1, setInputValue: setAddress1 },
                        {
                            type: "normal",
                            placeholder: "Address 2 (Optional)",
                            inputValue: address2,
                            setInputValue: setAddress2,
                        },
                        { type: "normal", placeholder: "City", inputValue: city, setInputValue: setCity },
                        {
                            type: "select",
                            placeholder: "States",
                            inputValue: selectedStates,
                            setInputValue: setSelectedStates,
                            dropdownValues: statesValues,
                        },
                    ]}
                    isRequired
                />
                <Divider marginTop={"11px"} thickness={"0px"} />
                <TitleAndInput
                    title={"Zip"}
                    type={"normal"}
                    placeholder={"Zip Code"}
                    inputValue={zip}
                    setInputValue={setZip}
                    tooltip={
                        <C3Text fontColor={Theme.color.gray500}>
                            Map You can add the exact store location on the map at the push of a button.
                        </C3Text>
                    }
                    gap={"11px"}
                    tooltipTop={"-500%"}
                    buttonIcon={"location_mark_black"}
                    buttonOnClick={() => setOpenLocationModal(true)}
                />
                <Divider marginTop={"11px"} marginBottom={"11px"} />
                <TitleAndInput
                    title={"Phone"}
                    type={"normal"}
                    placeholder={"000-0000-0000"}
                    inputValue={phone}
                    setInputValue={setPhone}
                />
                <Divider marginTop={"11px"} marginBottom={"11px"} lineStyle={"custom-dotted"} />
                <TitleAndInput
                    title={"Email"}
                    type={"email"}
                    placeholder={"example@domain.com"}
                    inputValue={email}
                    setInputValue={setEmail}
                    isValid={true}
                    isRequired
                />
                <Divider marginTop={"11px"} marginBottom={"11px"} lineStyle={"custom-dotted"} />
                <TitleAndInput
                    title={"Store Introduction"}
                    type={"textAria"}
                    placeholder={"Store Introduction"}
                    inputValue={introduction}
                    setInputValue={setIntroduction}
                    isValid={true}
                    isRequired
                />
                <Divider marginTop={"11px"} marginBottom={"11px"} lineStyle={"custom-dotted"} />
                <TitleAndInput title={"Image"} type={"image"} inputValue={image} setInputValue={setImage} />
            </SizedBox>
            <SizedBox height={"36px"} />
            <Row width={"100%"} justifyContent={"space-between"}>
                <SecondaryButton
                    onClick={() => setIsDeletePopupOpen(true)}
                    width={"60px"}
                    text={Translate("common.delete")}
                    fontColor={Theme.color.rose500}
                />
                <Row>
                    <SecondaryButton
                        onClick={() => setIsCancelPopupOpen(true)}
                        width={"60px"}
                        text={Translate("common.cancel")}
                    />
                    <SizedBox width={"10px"} />
                    <PrimaryButton onClick={handleUpdate} width={"60px"} text={Translate("common.save")} />
                </Row>
            </Row>
            <CustomPopup
                isOpen={isCancelPopupOpen}
                onClose={handleCancelClose}
                onConfirm={handleCancelOk}
                message={Translate("popup.cancel")}
            />
            <CustomPopup
                isOpen={isDeletePopupOpen}
                onClose={handleDeleteClose}
                onConfirm={handleDeleteOk}
                message={Translate("popup.delete")}
            />
            {openLocationModal && (
                <StoreLocationModal
                    isOpen={openLocationModal}
                    onClose={() => setOpenLocationModal(false)}
                    onConfirm={handleLocationConfirm}
                />
            )}
        </CustomModal>
    );
}

export default StoreEditModal;
